import { RootState } from '../';
import { campaignsAdapter, campaignsSlice } from './';

export const campaignsSelectors = campaignsAdapter.getSelectors<RootState>(
  (state) => state[campaignsSlice.name]
);
